import { render, staticRenderFns } from "./DefinitionCard.vue?vue&type=template&id=2adc4e46&scoped=true&"
import script from "./DefinitionCard.vue?vue&type=script&lang=js&"
export * from "./DefinitionCard.vue?vue&type=script&lang=js&"
import style0 from "./DefinitionCard.vue?vue&type=style&index=0&id=2adc4e46&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adc4e46",
  null
  
)

export default component.exports